export class UserConsents {
  id: number
  name: string;
  password: string;
  username: string;
}
